<script setup lang="ts">
import CTASection from '~/components/landing/CTASection.vue'
import FAQSection from '~/components/landing/FAQSection.vue'
import FeaturesSection from '~/components/landing/FeaturesSection.vue'
import HeroSection from '~/components/landing/HeroSection.vue'
import ImpactStatementSection from '~/components/landing/ImpactStatementSection.vue'
import PricingSection from '~/components/landing/PricingSection.vue'
import ProductShowcaseSection from '~/components/landing/ProductShowcaseSection.vue'
import TestimonialsSection from '~/components/landing/TestimonialsSection.vue'
import ValuePropositionSection from '~/components/landing/ValuePropositionSection.vue'
import Footer from '~/components/layout/Footer.vue'
import NavigationBar from '~/components/layout/NavigationBar.vue'

const { initLenis, destroyLenis } = useLenis()

onMounted(() => {
  initLenis()
})

onUnmounted(() => {
  destroyLenis()
})

useHead({
  title: 'Rintisan Billing - Aplikasi Invoice Terintegrasi',
  meta: [
    {
      name: 'description',
      content: 'Bayar Invoice dan Terima Pembayaran dengan mudah menggunakan Rintisan Billing. Platform invoice terintegrasi dengan MDR terendah se-Indonesia.',
    },
    {
      property: 'og:title',
      content: 'Rintisan Billing - Aplikasi Invoice Terintegrasi',
    },
    {
      property: 'og:description',
      content: 'Bayar Invoice dan Terima Pembayaran dengan mudah menggunakan Rintisan Billing. Platform invoice terintegrasi dengan MDR terendah se-Indonesia.',
    },
  ],
  link: [
    { rel: 'preload', as: 'image', href: '/images/primary/landing-content-1.png' },
  ],
})
</script>

<template>
  <main class="min-h-screen landing-page">
    <NavigationBar />

    <HeroSection />

    <ValuePropositionSection />

    <div class="bg-gradient-putih">
      <ImpactStatementSection />

      <TestimonialsSection />

      <FeaturesSection />

      <PricingSection />

      <ProductShowcaseSection />
    </div>

    <FAQSection />

    <CTASection />

    <Footer />
  </main>
</template>
